require('./src/css/tailwind-base.css')
require('./src/css/tailwind-components.css')
require('./src/css/tailwind-utilities.css')
require('./src/css/tailwind-variants.css')
